export const PAGE_SIZES = [25, 50, 100, 250, 500, 1000, 'all'];

export const DEFAULT_PAGE_SIZE = 50;

export const COLUMN_TYPES = {
    TEXT: 'text',
    NUMBER: 'number',
    IMAGE: 'image',
    DATE: 'date',
    CUSTOM: 'custom',
};

export const SORT_DIR = {
    ASC: 'asc',
    DESC: 'desc',
};

export const DEFAULT_COLUMN = {
    type: COLUMN_TYPES.TEXT,
    width: 150,
    minWidth: 60,
    maxWidth: 600,
    sticky: false,
    sortable: true,
    filterable: false,
    resizable: true,
    hidden: false,
    hideable: true,
    align: 'left',
    imageSize: 40,
    summary: null,
};

export const CELL_OVERFLOW_LENGTH = 80;
